import { gettext } from '@eventbrite/i18n';
import React, { useMemo } from 'react';
import { useIsFirstHierarchyLevel } from '../../../../experimentation';

import './AutoplayHeroVideo.scss';

type AutoplayHeroVideoProps = {
    url: string;
    alt: string;
    standalone?: boolean;
};

export const AutoplayHeroVideo: React.FC<AutoplayHeroVideoProps> = ({
    alt,
    url: urlProp,
    standalone = false,
}) => {
    const isNewHierarchyExperiment = useIsFirstHierarchyLevel();
    const embedUrlWithAutoplay = useMemo(() => {
        const url = new URL(urlProp);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        return url.toString();
    }, [urlProp]);

    const video = (
        <iframe
            style={{ width: '100%', height: '100%' }}
            src={embedUrlWithAutoplay}
            frameBorder="0"
            allowFullScreen
            allow="autoplay"
            title={alt || gettext('Video content').toString()}
        />
    );

    if (!standalone) {
        return video;
    }

    return (
        <div
            data-testid="autoplay-wrapper"
            className={`autoplayHeroVideo__wrapper${
                isNewHierarchyExperiment ? '--newHierarchy' : ''
            }`}
        >
            {video}
        </div>
    );
};
